import LoanType from 'src/app/shared/enums/LoanType.enum';
import InterestType from 'src/app/shared/enums/InterestType.enum';

export class LenderInformation {
  public lenderName: string;
  public amount: number;
  public loanToValue: number;
  public interestRate: number;
  public interestType: InterestType;
  public closingDate: Date;
  public maturityDate: Date;
  public additionalTerms: string;
  public loanType: LoanType;
  public totalFinancingPerGrossAreaUnit: number;
  public totalFinancingPerNetAreaUnit: number;

  public amountJunior: number;
  public loanToValueJunior: number;
  public interestRateJunior: number;
  public interestTypeJunior: InterestType;
  public closingDateJunior: Date;
  public maturityDateJunior: Date;
  public additionalTermsJunior: string;
  public loanTypeJunior: LoanType;
  public totalFinancingPerGrossAreaUnitJunior: number;
  public totalFinancingPerNetAreaUnitJunior: number;
}
